export default __webpack_public_path__ + "static/media/icon_down_arrow.1d634f20.svg";